module.exports = __webpack_public_path__ + "static/gym-078f8c7d6e023f7e11ef2e9186e9a442.png";